/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PageHeader from "../../../components/PageHeader";
import { ControlTable } from "../../../components/Table";
import Filters from "../../../components/Filters";
import { dateToFormat, getYearRange } from "../../../utils/date";
import { getSalariesHistoriesList } from "../../../apis/salary/salary-history";
import PayStub from "../Component/PayStub";
import { shallowEqual, useSelector } from "react-redux";
import { cloneDeep, get, isEmpty } from "lodash";
import { getParams } from "../../../utils/params";
import useForm from "../../../hooks/useForm";
import { useHistory } from "react-router-dom";
import { permissionCheck } from "../../../utils/permission";

const SalarySelf = () => {
  const history = useHistory();
  const { user, permissions } = useSelector(
    (store) => ({
      user: store.Profile.user,
      permissions: store.Profile.permissions,
    }),
    shallowEqual
  );

  const [fields] = useState([
    { title: "급여년월일", key: "payDate" },
    { title: "급여형태", key: "payType" },
    {
      title: "지급총액",
      key: "totalAllowance",
      type: "comma"
    },
    {
      title: "공제총액",
      key: "totalDeduction",
      type: "comma"
    },
    {
      title: "차인지급액",
      key: "paymentByDifference",
      type: "comma"
    },
  ]);
  const [detailOpen, setDetailOpen] = useState(false);
  const [detailList, setDetailList] = useState({});
  const [targetPermission, setTargetPermission] = useState(null);

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'SALARY');
      setTargetPermission(permission);
      if (isEmpty(permission)) {
        permissionCheck(history, "SALARY");
      }
    }
  }, [permissions]);

  const {
    form,
    setSubmit,
    handleOnChange,
    // LIST 용
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
  } = useForm(
    {
      range: {
        payDate: {
          from: `${new Date().getFullYear()}-01-01`,
          to: `${new Date().getFullYear()}-12-31`,
        },
      },
      term: String(new Date().getFullYear()),
      page: 0,
      limit: 999
    },
  );

  useEffect(() => {
    if (!isEmpty(user)) {
      submit(form);
      setSubmit(submit);
    }
  }, [user]);

  const submit = (params) => {
    let _params = cloneDeep(params);
    if (!isEmpty(_params.term)) {
      _params.range.payDate = {
        from: `${_params.term}-01-01`,
        to: `${_params.term}-12-31`
      };
    }

    delete _params.term;

    setIsLoading(true);
    getSalariesHistoriesList({
      search: {
        employeeIdx: get(user, "employeeIdx"),
        exposureDate: dateToFormat()
      },
      ...getParams(_params),
    })
      .then((res) => {
        setList(res.data.salaryHistories);
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const filters = [
    {
      title: "기간",
      type: "select",
      key: "term",
      options: {
        list: getYearRange(),
      },
    },
  ];

  const onRowClick = (data) => {
    setDetailOpen(true);
    setDetailList(data);
  };

  return (
    !isEmpty(targetPermission) && (
      <>
        <div className="print-out">
        <PageHeader title={"나의 급여 조회"} />
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange} />
        <ControlTable
          isHideControlHeader
          isLoading={isLoading}
          fields={fields}
          list={list}
          onSelect={onRowClick}
        />
        </div>
        <PayStub
          open={detailOpen}
          setOpen={setDetailOpen}
          list={detailList}
          setList={setDetailList}
        />
      </>
    )
  );
};

export default SalarySelf;
